<div class="chart-container">
  @if (overlap) {
    <ngx-charts-line-chart
      [results]="sensorData"
      [animations]="animations"
      [legend]="false"
      [xAxis]="true"
      [yAxis]="true"
      [gradient]="false"
      [showXAxisLabel]="false"
      [showYAxisLabel]="true"
      [showGridLines]="true"
      [curve]="curve"
      [customColors]="customColors"
      [yScaleMin]="0"
      [yScaleMax]="100"
      [xAxisTickFormatting]="formatLabel"
      [yAxisTickFormatting]="formatPercentage"
    >
      <ng-template #tooltipTemplate let-model="model">
        @if (getTooltipPoint(model); as point) {
          <ng-container
            [ngTemplateOutlet]="tooltipContentTemplate"
            [ngTemplateOutletContext]="{ point }"
          />
        }
      </ng-template>

      <ng-template #seriesTooltipTemplate let-model="model">
        @if (getTooltipPoint(model); as point) {
          <ng-container
            [ngTemplateOutlet]="tooltipContentTemplate"
            [ngTemplateOutletContext]="{ point }"
          />
        }
      </ng-template>
    </ngx-charts-line-chart>

    <div class="chart-legend">
      @for (series of legendData; track series.name) {
        <div class="chart-legend__item">
          <span
            class="chart-legend__color"
            [style.background-color]="series.color"
          ></span>

          {{ series.name }}
        </div>
      }
    </div>
  } @else {
    <ngx-charts-area-chart
      [results]="sensorData"
      [animations]="animations"
      [legend]="false"
      [xAxis]="true"
      [yAxis]="true"
      [gradient]="true"
      [showXAxisLabel]="false"
      [showYAxisLabel]="true"
      [showGridLines]="true"
      [curve]="curve"
      [customColors]="customColors"
      [yScaleMin]="0"
      [yScaleMax]="100"
      [xAxisTickFormatting]="formatLabel"
      [yAxisTickFormatting]="formatPercentage"
    >
      <ng-template #tooltipTemplate let-model="model">
        @if (getTooltipPoint(model); as point) {
          <ng-container
            [ngTemplateOutlet]="tooltipContentTemplate"
            [ngTemplateOutletContext]="{ point }"
          />
        }
      </ng-template>

      <ng-template #seriesTooltipTemplate let-model="model">
        @if (getTooltipPoint(model); as point) {
          <ng-container
            [ngTemplateOutlet]="tooltipContentTemplate"
            [ngTemplateOutletContext]="{ point }"
          />
        }
      </ng-template>
    </ngx-charts-area-chart>
  }

  <ng-template #tooltipContentTemplate let-point="point">
    <div class="chart-tooltip">
      @if (point.seriesLabel) {
        <div class="chart-tooltip__sub-label">{{ point.seriesLabel }}</div>
      }
      <div class="chart-tooltip__label">{{ formatTooltipDate(point) }}</div>
      @if (!point.value || !point.absoluteLiters) {
        {{ "statistics.empty" | translate }}
      } @else {
        <div>
          {{ "statistics.levelChart.tooltip.percentage" | translate }}:
          {{ point.value | localizedNumber: "1.0-0" }} % ({{
            point.absoluteLiters | localizedNumber: "1.0-0"
          }}
          l)
        </div>
      }
    </div>
  </ng-template>
</div>
